/**
 * Our search bar component, mostly used in typeaheads. This is
 */
export const MobileSearchBar = Backbone.Marionette.Layout.extend({
    template: '#tpl_search_bar',
    className: 'search_wrapper',

    collection: null, // usually the collection for the parent view
    i18n_key_placeholder: 'mobile_placeholder_search_bar',
    default_value: '',
    is_search_running: 0, // a timeoutId from JS
    search_delay: 1000,
    min_chars: 1, // 0 index, 1 is 2 characters required for search

    // callbacks passed in from caller
    on_search_clear: function () {},
    search: function (query, callback) {
        throw new Error('Programmer Error: MobileSearchBar needs implemented search() method.');
    },

    // @todo: there may be more common functionality we can stuff in here, such as delays in search
    // (though that may go better in the collection), etc.

    events: {
        'keyup .search': 'search_keypress',
        'click .clear_search': 'clear_search',
        'focus .search': 'on_focus',
        'blur .search': 'on_blur'
    },

    templateHelpers: function () {
        return {
            default_value: this.default_value,
            placeholder: _t(this.i18n_key_placeholder) || this.i18n_key_placeholder
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onRender: function () {
        this.determine_has_value();
    },

    search_keypress: function (event) {
        var _this = this;
        var query = event.target.value;

        if (query.length == 0) {
            query = '';
        }

        // don't run a search until > N keys are typed
        if (query.length <= this.min_chars && query.length != 0) {
            return;
        }

        clearTimeout(this.is_search_running);
        this.is_search_running = setTimeout(function () {
            _this.search(query);
        }, _this.search_delay);
    },

    clear_search: function (event) {
        this.$el.find('.search').val('');
        this.search('');

        this.on_search_clear(event);
        this.determine_has_value();

        return false;
    },

    on_focus: function (event) {
        this.$el.addClass('search_active');
    },

    on_blur: function (event) {
        this.$el.removeClass('search_active');
        this.determine_has_value();
    },

    determine_has_value: function () {
        if (this.$el.find('.search').val()) {
            this.$el.addClass('search_has_val');
        } else {
            this.$el.removeClass('search_has_val');
        }
    }
});
